export default {
  badge: "Condado de Orange, California",
  headline1: "El Viaje de Tu Food Truck",
  headline2: "Comienza con la Documentación Correcta",
  subtitle:
    "La primera agencia de consultoría para food trucks del Condado de Orange. Nos encargamos de los permisos, las aprobaciones del departamento de salud y las regulaciones de la ciudad para que tú puedas concentrarte en servir buena comida.",
  bookSession: "Reservar una Sesión",
  exploreServices: "Explorar Nuestros Servicios",
  phases: ["Consulta con el Cliente", "Documentación de Permisos", "Revisión Regulatoria", "Permiso Aprobado"],
};